export {
  Card as ActivityCard,
  type CardProps as ActivityCardProps,
} from "./ui";
